var ks = ks || {};

// animation on elements
//-----------------------------------------------------------------

ks.animation = function () {
  var $animClass = ".js_animate";
  var $animations = $($animClass);

  if (!$animations.length) {
    return;
  }

  $(".js_animate").one("inview", function (event, isInView) {
    $this = $(this);

    if (isInView) {
      $this.addClass("animated");
    } else {
    }
  });
};

ks.slideIn = function () {
  var $slideClass = ".js_slideIn";
  var $slides = $($slideClass);

  if (!$slides.length) {
    return;
  }

  $(".js_slideIn").one("inview", function (event, isInView) {
    $this = $(this);

    if (isInView) {
      $this.addClass("slide-in");
    } else {
    }
  });
};

ks.drawPath = function () {
  var $drawClass = ".js_drawPath";
  var $draw = $($drawClass);

  if (!$draw.length) {
    return;
  }

  

  $(".js_drawPath").one("inview", function (event, isInView) {
    $this = $(this);

    if (isInView) {
      TweenMax.from(".cls-1", 3, {x:"50%", scale:.1});
    } else {
    }
  });
};

$(document).ready(function () {
  ks.animation();
  ks.slideIn();
  ks.drawPath();
});
